import * as Yup from 'yup';

const address2 = Yup.string().when('isRm', {
  is: true,
  then: Yup.string().required('Apartment, suite, unit, building, etc. is required'),
});

export default address2;
